

function AppFooter() {
  return (
    <>
      <footer className="site-footer">
      <div className="footer-inner">
        <ul className="nav justify-content-center border-bottom pb-3 mb-3">
      <li className="nav-item"><a href="/" className="nav-link px-2">Explore</a></li>
      <li className="nav-item"><a href="/videos" className="nav-link px-2">Videos</a></li>
      <li className="nav-item"><a href="/channels" className="nav-link px-2">Channels</a></li>
      <li className="nav-item"><a href="/create" className="nav-link px-2">Write a post</a></li>
        <li className="nav-item"><a href="/about" className="nav-link px-2 text-body-secondary">About</a></li>
      <li className="nav-item"><a href="/auth" className="nav-link px-2 text-body-secondary">Join</a></li>
        <li className="nav-item"><a href="/support" className="nav-link px-2 text-body-secondary">Support</a></li>
        </ul>
        <p className="text-center text-body-secondary">{new Date().getFullYear()} ©Haroldas Varanauskas</p>
      </div>
        </footer>
    </>
   
  );
}

export default AppFooter;